import { render, staticRenderFns } from "./history_chat.vue?vue&type=template&id=3009053d"
import script from "./history_chat.vue?vue&type=script&lang=js"
export * from "./history_chat.vue?vue&type=script&lang=js"
import style0 from "./history_chat.vue?vue&type=style&index=0&id=3009053d&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports